import { Box, Typography } from "@mui/material";
import { AgGridReact } from "ag-grid-react";
import React from "react";
import { useState } from "react";
import { useMemo } from "react";
import {
  addWareHouseAccesses,
  revokeExternalReferralAccesses,
} from "../../api/group";
import FlagIcon from "../../assets/SVG/flagIcon";

export default function TableErjaAdmin({
  rowData,
  setRowData,
  equipment,
  drug,
}) {
  const [colDefs] = useState([
    {
      field: "area",
      headerName: "نام کاربر",
      width: 190,
      cellRenderer: (x) => {
        return (
          <Typography fontFamily={"Shabnam"}>{x.data.user.name}</Typography>
        );
      },
    },

    {
      field: "dose",
      headerName: "عملیات",
      width: 190,
      cellRenderer: (x) => {
        return (
          <Box display="flex" alignItems="center">
            <button
              style={{
                display: "flex",
                border: "none",
                background: "#D43333",
                borderRadius: "9px",
                padding: "5px",
                // fontFamily: "Shabnam !important ",
              }}
              onClick={() => {
                if (equipment) {
                  addWareHouseAccesses({
                    userId: x.data.user.id,
                    equipmentAccess: false,
                  })
                    .then(() => {
                      setRowData((z) => {
                        let array = [...z];
                        let result = array.filter((y) => y.id !== x.data.id);
                        return result;
                      });
                    })
                    .catch(() => {});
                } else if (drug) {
                  addWareHouseAccesses({
                    userId: x.data.user.id,
                    drugAccess: false,
                  })
                    .then(() => {
                      setRowData((z) => {
                        let array = [...z];
                        let result = array.filter((y) => y.id !== x.data.id);
                        return result;
                      });
                    })
                    .catch(() => {});
                } else {
                  revokeExternalReferralAccesses(x.data.user.id)
                    .then(() => {
                      setRowData((z) => {
                        let array = [...z];
                        let result = array.filter((y) => y.id !== x.data.id);
                        return result;
                      });
                    })
                    .catch(() => {});
                }
              }}
            >
              <FlagIcon color="white" />
              <Typography color="white" fontSize="14px" fontFamily="Shabnam">
                لغو دسترسی
              </Typography>
            </button>
          </Box>
        );
      },
    },
  ]);

  const defaultColDef = useMemo(() => ({
    filter: true,
    editable: true,
  }));
  return (
    // <Box calssName="table_drug_griups">
    <div className="ag-theme-quartz" style={{ height: 260, marginTop: 10 }}>
      <AgGridReact
        // pagination={true}
        rowHeight={60}
        enableRtl={true}
        rowData={rowData}
        rowStyle={{ backgroundColor: "#F5F9FF" }}
        // ref={gridRef}
        columnDefs={colDefs}
        defaultColDef={defaultColDef}
        className="table_drug_griups"
      />
    </div>
    // </Box>
  );
}
